
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Stethoscope, Calendar, User, FileText, Camera } from 'lucide-react';

const PatientTreatments = () => {
  const treatments = [
    {
      id: '1',
      date: '2024-01-15',
      treatment: 'Botox - Forehead & Glabella',
      provider: 'Dr. Johnson',
      units: 25,
      cost: 375.00,
      notes: 'Patient tolerated well, no adverse reactions',
      beforePhoto: true,
      afterPhoto: false
    },
    {
      id: '2',
      date: '2024-01-05',
      treatment: 'Dermaplaning Facial',
      provider: 'Sarah M.',
      cost: 150.00,
      notes: 'Excellent results, skin texture improved significantly',
      beforePhoto: true,
      afterPhoto: true
    },
    {
      id: '3',
      date: '2023-12-20',
      treatment: 'Initial Consultation',
      provider: 'Dr. Smith',
      cost: 0,
      notes: 'Discussed treatment options, patient interested in Botox',
      beforePhoto: false,
      afterPhoto: false
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold font-juv-heading" style={{ color: '#5C322B' }}>
          Treatment History
        </h2>
        <Button className="text-white" style={{ backgroundColor: '#A55C52' }}>
          <Stethoscope className="h-4 w-4 mr-2" />
          Add Treatment Record
        </Button>
      </div>

      <div className="grid gap-6">
        {treatments.map((treatment) => (
          <Card key={treatment.id}>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="flex items-center space-x-2">
                  <Stethoscope className="h-5 w-5" style={{ color: '#A55C52' }} />
                  <span>{treatment.treatment}</span>
                </CardTitle>
                <Badge variant="outline">
                  {new Date(treatment.date).toLocaleDateString()}
                </Badge>
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <Calendar className="h-4 w-4" />
                    <span>{new Date(treatment.date).toLocaleDateString()}</span>
                  </div>
                  
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <User className="h-4 w-4" />
                    <span>Provider: {treatment.provider}</span>
                  </div>
                  
                  {treatment.units && (
                    <div className="text-sm">
                      <span className="font-medium">Units:</span> {treatment.units}
                    </div>
                  )}
                  
                  <div className="text-sm">
                    <span className="font-medium">Cost:</span> ${treatment.cost}
                  </div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-1">
                      <Camera className="h-4 w-4" />
                      <span className="text-sm">Before:</span>
                      <Badge variant={treatment.beforePhoto ? "default" : "secondary"}>
                        {treatment.beforePhoto ? "✓" : "✗"}
                      </Badge>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Camera className="h-4 w-4" />
                      <span className="text-sm">After:</span>
                      <Badge variant={treatment.afterPhoto ? "default" : "secondary"}>
                        {treatment.afterPhoto ? "✓" : "✗"}
                      </Badge>
                    </div>
                  </div>
                </div>
                
                <div>
                  <div className="flex items-center space-x-2 mb-2">
                    <FileText className="h-4 w-4" style={{ color: '#A55C52' }} />
                    <span className="font-medium">Treatment Notes</span>
                  </div>
                  <p className="text-sm text-gray-700 bg-gray-50 p-3 rounded-lg">
                    {treatment.notes}
                  </p>
                </div>
              </div>
              
              <div className="mt-4 flex space-x-2">
                <Button variant="outline" size="sm">
                  View Photos
                </Button>
                <Button variant="outline" size="sm">
                  Edit Record
                </Button>
                <Button variant="outline" size="sm">
                  Add Follow-up
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PatientTreatments;
